import React from 'react';
import { Link } from 'react-router-dom';

interface PublicLayoutProps {
  children: React.ReactNode;
}
const currentYear = new Date().getFullYear();
const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-white font-sans flex flex-col">
      {/* Nav */}
      <nav className="flex justify-between items-center px-6 py-4 border-b border-gray-100 sticky top-0 bg-white z-50">
        <Link to="/" className="flex items-center gap-2">
          <img src="/images/Manatomy_favicon.png" width="24" alt="Manatomy AI" />
          <span className="text-base font-semibold tracking-wide text-gray-900">
            MANATOMY AI
          </span>
        </Link>

        <div className="hidden md:flex gap-7 text-sm text-gray-500">
          <a href="/#how-it-works" className="hover:text-gray-900 transition-colors">How it works</a>
          <a href="/#testimonials" className="hover:text-gray-900 transition-colors">Reviews</a>
          <a href="/#faq" className="hover:text-gray-900 transition-colors">FAQ</a>
        </div>

        <Link
          to="/quick-start"
          className="bg-gray-900 text-white text-xs font-medium px-4 py-2 rounded-md hover:bg-gray-700 transition-colors"
        >
          Get started
        </Link>
      </nav>

      <main className="flex-1">
        {children}
      </main>

      {/* Footer */}
      <footer className="py-10 border-t border-gray-100 px-6">
        <div className="max-w-xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <img src="/images/Manatomy_favicon.png" width="22" alt="Manatomy AI" />
              <span className="text-sm font-semibold text-gray-900">
                Manatomy AI
              </span>
            </div>
            <p className="text-xs text-gray-400 leading-relaxed mb-2">AI-powered personal styling for the modern man.</p>
            <p className="text-xs text-gray-400">Phone: <a href="tel:917065787678" className="hover:text-gray-700">+91 70657 87678</a></p>
            <p className="text-xs text-gray-400 mt-1">Email: <a href="mailto:help@themanatomy.com" className="hover:text-gray-700">help@themanatomy.com</a></p>
          </div>
          <div>
            <h4 className="text-sm font-medium text-gray-900 mb-3">Collections</h4>
            <ul className="space-y-1.5">
              <li><a href="https://themanatomy.com/collections/topwear" target="_blank" rel="noreferrer" className="text-xs text-gray-400 hover:text-gray-700">Topwear</a></li>
              <li><a href="https://themanatomy.com/collections/bottomwear" target="_blank" rel="noreferrer" className="text-xs text-gray-400 hover:text-gray-700">Bottomwear</a></li>
              <li><a href="https://themanatomy.com/collections/shoes-belt" target="_blank" rel="noreferrer" className="text-xs text-gray-400 hover:text-gray-700">Shoes & Belt</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-medium text-gray-900 mb-3">Policies</h4>
            <ul className="space-y-1.5">
              <li><Link to="/terms-of-service" className="text-xs text-gray-400 hover:text-gray-700">Terms of Service</Link></li>
              <li><Link to="/privacy-policy" className="text-xs text-gray-400 hover:text-gray-700">Privacy Policy</Link></li>
              <li><Link to="/cookie-policy" className="text-xs text-gray-400 hover:text-gray-700">Cookie Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-gray-100 text-center">
          <p className="text-xs text-gray-400">© {currentYear} - The Manatomy | All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default PublicLayout;
